import { cva } from "class-variance-authority";

export { default as Breadcrumb } from "./Breadcrumb";

export const types = ["text", "text-lines", "button-brand", "button-gray"];
export const sizes = ["sm", "md"];

export const containerVariants = cva(
    ["flex", "w-fit", "no-scrollbar", "min-w-0"],
    {
        variants: {
            type: {
                "text-lines": ["border-y", "border-secondary", "py-2"],
            },
            isScrollable: {
                false: ["overflow-hidden", "max-w-full"],
                true: ["overflow-x-auto", "max-w-auto"],
            },
        },
        compoundVariants: [
            {
                type: ["text-lines"],
                size: ["sm"],
                class: ["ltr:pl-2", "rtl:pr-2"],
            },
            {
                type: ["text"],
                size: ["md"],
            },
        ],
    }
);

export const itemVariants = cva(
    ["font-medium", "truncate", "max-w-full", "block", "cursor-default"],
    {
        variants: {
            type: {
                text: ["breadcrumb-fg", "hover:breadcrumb-fg_hover", "p-0"],
                "text-lines": [
                    "breadcrumb-fg",
                    "hover:breadcrumb-fg_hover",
                    "p-0",
                ],
                "button-brand": [
                    "hover:breadcrumb-brand-bg_hover",
                    "hover:breadcrumb-brand-fg_hover",
                ],
                "button-gray": [
                    "hover:breadcrumb-bg_hover",
                    "hover:breadcrumb-fg_hover",
                ],
            },
        },
        compoundVariants: [
            {
                active: true,
                type: ["text", "text-lines"],
                class: ["font-semibold", "text-primary"],
            },
            {
                active: true,
                type: ["button-brand"],
                class: [
                    "breadcrumb-brand-bg_hover",
                    "breadcrumb-brand-fg_hover",
                    "font-semibold",
                ],
            },
            {
                active: true,
                type: ["button-gray"],
                class: [
                    "breadcrumb-bg_hover",
                    "breadcrumb-fg_hover",
                    "font-semibold",
                ],
            },
            {
                size: "sm",
                class: ["text-style-xs"],
            },
            {
                size: "md",
                class: ["text-style-sm"],
            },
        ],
    }
);

export const dividerVariants = cva(
    ["fg-senary", "shrink-0", "block", "rtl:rotate-180", "cursor-default"],
    {
        variants: {},
        compoundVariants: [
            {
                size: ["sm"],
                type: ["text"],
                class: ["w-3", "h-3", "mx-0.5"],
            },
            {
                size: ["sm"],
                type: ["text-lines"],
                class: ["w-3", "h-3", "mx-1"],
            },
            {
                size: ["sm"],
                type: ["button-gray", "button-brand"],
                class: ["w-4", "h-4", "mx-1"],
            },

            {
                size: ["md"],
                type: ["text"],
                class: ["w-4", "h-4", "mx-1"],
            },
            {
                size: ["md"],
                type: ["text-lines"],
                class: ["w-4", "h-4", "mx-2"],
            },
            {
                size: ["md"],
                type: ["button-gray", "button-brand"],
                class: ["w-4", "h-4", "mx-1.5"],
            },
        ],
    }
);
